import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { AppText, Button, Card } from "./ui";

const D_LABELS = { D1: "tourne", D2: "saut", D3: "debout", D4: "assis", D5: "pieds", D6: "tabouret" };

export function MotorRecalc() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [onlyChanged, setOnlyChanged] = useState(true);
  const load = async () => {
    setBusy(true);
    try { setData(await api.coachMotorRecalc()); } catch (e) { toast.error(e.message || "Erreur"); } finally { setBusy(false); }
  };
  const apply = async (ids) => {
    if (!ids.length) return;
    if (!window.confirm(`Appliquer le nouveau profil moteur à ${ids.length} coureur(s) ?`)) return;
    setBusy(true);
    try { const r = await api.coachMotorRecalcApply(ids); toast.success(`${r.applied} profil(s) mis à jour`); await load(); }
    catch (e) { toast.error(e.message || "Erreur"); setBusy(false); }
  };
  const rows = (data?.runners || []).filter((r) => !onlyChanged || r.changes || r.refine);
  return (
    <Card className="flex flex-col gap-3" testID="motor-recalc">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex-1 min-w-[200px]">
          <AppText variant="bodyStrong">Recalcul des profils moteur</AppText>
          <AppText variant="caption" className="text-km-muted">Rejoue les notes ci-dessus sur les réponses de chaque coureur et montre ceux dont le profil changerait (Anthony, Stéphane…). Rien ne bouge tant que tu n'appliques pas.</AppText>
        </div>
        <Button title={data ? "Recalculer" : "Recalculer les profils"} size="md" variant="secondary" onClick={load} loading={busy} testID="motor-recalc-run" />
      </div>
      {data ? (
        <>
          <div className="flex flex-wrap items-center gap-3">
            <AppText variant="caption" data-testid="motor-recalc-summary"><b>{data.changed}</b> changement(s) sur {data.runners.length} coureur(s) avec bloc D{data.refinable ? ` · ${data.refinable} à préciser (pieds / cuisses)` : ""}</AppText>
            <label className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={onlyChanged} onChange={(e) => setOnlyChanged(e.target.checked)} className="w-4 h-4 accent-km-coral" data-testid="motor-recalc-only-changed" /><AppText variant="caption">Seulement ceux qui changent</AppText></label>
            {data.changed || data.refinable ? <Button title={data.changed ? "Appliquer tous les changements" : "Préciser pieds / cuisses pour tous"} size="md" onClick={() => apply(data.runners.filter((r) => r.changes || r.refine).map((r) => r.runner_id))} disabled={busy} testID="motor-recalc-apply-all" /> : null}
          </div>
          <div className="flex flex-col divide-y divide-km-divider" data-testid="motor-recalc-rows">
            {rows.length === 0 ? <AppText variant="caption" className="text-km-muted py-2">Aucun profil ne change avec les notes actuelles.</AppText> : rows.map((r) => (
              <div key={r.runner_id} className="py-2 flex flex-wrap items-center gap-x-3 gap-y-1" data-testid={`motor-recalc-${r.runner_id}`}>
                <div className="flex-1 min-w-[160px]">
                  <AppText variant="caption" className="font-bold">{r.first_name || r.email}{r.set_by_coach ? " · tranché par toi" : ""}</AppText>
                  <AppText variant="caption" className="text-km-muted">{Object.entries(r.answers).map(([q, v]) => `${D_LABELS[q]} : ${v}`).join(" · ")}</AppText>
                </div>
                <AppText variant="caption" className={r.changes ? "text-km-coral font-bold" : "text-km-muted"}>{r.current} → {r.computed}{r.score != null ? ` (${String(r.score).replace(".", ",")})` : ""}</AppText>
                {r.changes || r.refine ? <Button title="Appliquer" size="md" variant="secondary" onClick={() => apply([r.runner_id])} disabled={busy} testID={`motor-recalc-apply-${r.runner_id}`} /> : null}
              </div>
            ))}
          </div>
        </>
      ) : null}
    </Card>
  );
}
